import { defineAction } from "rd-action-creators";

export const putCountrySvgToStoreAction = defineAction<{ countryIsoCode: string; countrySVG: string }>(
    "PUT COUNTRY SVG TO STORE"
);
